// Which eye. Its own file so no module needs the mesh loader for a two-value union.

export type EyeSide = 'left' | 'right'

export const EYE_SIDES: EyeSide[] = ['left', 'right']
